import React from "react";
import { ArrowUpRight, ShieldAlert, Brain, Presentation, HeartPulse, ShoppingCart, Image, Waves, Building, Calendar } from "lucide-react";
import "../styles/Projects.css";

const projects = [
  {
    title: "Goa Patrols — AI-Powered Cyber Patrolling Tool",
    subtitle: "Currently in use by Goa Police",
    icon: ShieldAlert,
    description: "AI-driven cyber monitoring system detecting fraudulent content across Telegram, Twitter, and the web. Features include Telegram Scam Detector with dynamic Threat Scoring, Twitter Scam Monitor with real-time risk ranking, AI Hotel Authenticity Webcrawler, and centralised Public Reporting Portal with Firestore integration for case management.",
    tech: ["React", "FastAPI", "Firebase", "Gemini AI", "Telegram API", "Twitter API"],
    link: null,
  },
  {
    title: "MindWell — AI-Powered Mental Wellness Platform",
    icon: Brain,
    description: "Digital mental wellness ecosystem aligned with UN SDG 3 providing affordable, stigma-free psychological support. Features AI chat assistant with prompt-engineered LLM responses, mood-tracking dashboard with personalized content recommendations, and secure backend with privacy-focused storage.",
    tech: ["React", "FastAPI", "Firebase", "Gemini Pro", "Ollama"],
    link: "https://ai-mental-health-assistant-chi.vercel.app/",
  },
  {
    title: "AI Smart Presentation Generator",
    icon: Presentation,
    description: "Full-stack AI system generating structured slide content from plain-text topic input with integrated image suggestions. Features modular backend pipeline organizing presentations into logical sections, significantly reducing manual preparation time.",
    tech: ["React", "FastAPI", "Gemini Pro"],
    link: "https://ai-smart-presentation-generator.vercel.app/",
  },
  {
    title: "Safe Haven Device — IoT Fall Detection",
    icon: HeartPulse,
    description: "Wearable IoT system for elderly care detecting falls via accelerometer and gyroscope motion sensing combined with heart-rate monitoring. Features threshold-based detection with emergency alert triggering via Firebase and reduced false positives through combined motion and biometric validation.",
    tech: ["ESP32-S2", "MAX30102", "MPU-6050", "Firebase"],
    link: null,
  },
  {
    title: "Smart Consumer Guide",
    icon: ShoppingCart,
    description: "App that empowers consumers by scanning barcodes to retrieve nutritional data and AI-powered product insights.",
    tech: ["React", "FastAPI", "Gemini"],
    link: "https://smart-consumer-guide.vercel.app/",
  },
  {
    title: "Animal Image Classification",
    icon: Image,
    description: "Deep learning system classifying images into 19 animal categories using a fine-tuned ResNet18 model.",
    tech: ["PyTorch", "FastAPI", "React"],
    link: "https://animal-classification-frontend.vercel.app/",
  },
  {
    title: "EcoShores Goa",
    icon: Waves,
    description: "Community platform for environmental sustainability with garbage reporting, beach cleanup coordination, and eco-shopping.",
    tech: ["React", "Firebase"],
    link: "https://eco-shores-goa.vercel.app/",
  },
  {
    title: "Hotel Management System",
    icon: Building,
    description: "Web application for room booking and staff management with complete backend CRUD functionality.",
    tech: ["HTML", "CSS", "JS", "PHP", "MySQL"],
    link: "https://nikhil181511.github.io/Hotel-Management/",
  },
  {
    title: "Event Management Platform",
    icon: Calendar,
    description: "Modern web platform for event registration, promotion, and management with user/organizer dashboards.",
    tech: ["HTML", "CSS", "JS", "PHP", "MySQL"],
    link: "https://nikhil181511.github.io/Event-management/",
  },
];

const Projects = () => {
  return (
    <section className="projects">
      <div className="projects-header">
        <p className="projects-label">Selected Work</p>
        <h2>Projects</h2>
        <p className="projects-subtitle">
          A collection of projects spanning AI, web development, IoT, and cloud — each solving real-world problems.
        </p>
      </div>

      <div className="projects-grid">
        {projects.map((project, index) => {
          const IconComponent = project.icon;
          return (
            <div className="project-card" key={index}>
              <div className="project-icon-wrapper">
                <IconComponent size={24} strokeWidth={1.5} />
              </div>
              <h3>{project.title}</h3>
              {project.subtitle && (
                <p className="project-subtitle">{project.subtitle}</p>
              )}
              <p>{project.description}</p>
              <div className="project-tech">
                {project.tech.map((t, i) => (
                  <span key={i} className="tech-tag">{t}</span>
                ))}
              </div>
              {project.link && (
                <a href={project.link} target="_blank" rel="noreferrer" className="project-link">
                  View Live <ArrowUpRight size={14} />
                </a>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;
